let preserveConversationOnNextHydrate = false;

export const modeSwitchConversationPreservation = {
	mark: (): void => {
		preserveConversationOnNextHydrate = true;
	},
	consume: (): boolean => {
		const shouldPreserve = preserveConversationOnNextHydrate;
		preserveConversationOnNextHydrate = false;
		return shouldPreserve;
	},
	clear: (): void => {
		preserveConversationOnNextHydrate = false;
	},
} as const;
